export function normalizePathItemName(name: string): string {
  return name.replaceAll('\t', ' ')
}
